{
  "id": "artemis",
  "pantheon": "greeks",
  "name": {
    "pt-BR": "Ártemis",
    "en": "Artemis"
  },
  "icon": "gods/artemis",
  "portrait": "gods/artemis-portrait",
  "age": "mythic",
  "freeUnitsOnAgeUp": {
    "chimera": 1
  },
  "unlocks": ["chimera", "shafts-of-plague", "flames-of-typhon", "beast-slayer"],
  "powers": ["earthquake"],
  "meta": {
    "source": "Game files 19.17020 (techtree.xml)",
    "checkedAt": "2026-10-18",
    "confidence": "high",
    "note": "MythicAgeArtemis: CreateUnit Chimera at a Temple (one free myth unit), god power Earthquake (cooldown 240 s); enables the listed unit and techs."
  }
}
